import React, { FC } from 'react'
import { Jumbotron, Row, Col } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import ResetPasswordForm from './ResetPasswordForm'
import LoadingButton from '../../LoadingButton'
import LoginLayout from '../layout'
import './styles.scss'

const ResetPassword: FC<RouteComponentProps> = ({ history }) => {
  return (
    <LoginLayout>
      <Jumbotron className="reset-password">
        <Row className="title">
          <Col>
            <h3>Reset Password</h3>
          </Col>
        </Row>
        <Row className="form">
          <Col>
            <ResetPasswordForm />
            <LoadingButton
              className="register-button"
              variant="primary"
              type="submit"
              block
              onClick={(): void => history.push('/')}
              isLoading={false}
            >
              BACK
            </LoadingButton>
          </Col>
        </Row>
      </Jumbotron>
    </LoginLayout>
  )
}

export default withRouter(ResetPassword)
